import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '首页', path: '/' },
    { label: '功能介绍', path: '/category/features' },
    { label: '使用教程', path: '/category/tutorials' },
  ],
  资源中心: [
    { label: '用户评价', path: '/category/reviews' },
    { label: '常见问题', path: '/category/faq' },
    { label: '最新版本', path: '/category/versions' },
  ],
  关于我们: [
    { label: '品牌介绍', path: '/about' },
    { label: '联系我们', path: '/about#contact' },
    { label: '用户口碑', path: '/about#reputation' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-xl font-bold text-background-50">
              91c
            </Link>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              您值得信赖的首选平台，汇聚核心功能、使用指南与用户评价，为您提供最全面的信息与服务入口。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 91c. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}